import React from "react";

import { Link } from "react-router-dom";
import { dataListsType } from "./featured-posts";
import LazyImage from "./lazyImage";

type Props = {
  props: dataListsType[];
};

const CardGrey: React.FC<Props> = ({ props }) => {
  return (
    <>
      {props.map((item, key) => {
        return (
          <Link
            target="_top"
            to={{
              pathname: `/detailspage`,
              search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
            }}
            key={key}
          >
            <div className="flex items-center mb-7 p-[0px] hover:text-[#5b68d3] rounded-md bg-[#fff] border-[0px] border-[#e7e9eb] transform transition-transform duration-500 ease-in-out hover:-translate-y-2 cursor-pointer">
              <div className="w-24 h-24 flex-shrink-0 rounded-full overflow-hidden shadow-md mr-4">
                <LazyImage
                  src={item.images[0]}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col justify-between py-0">
                <span className="line-clamp-2 mt-0">
                  <b className="text-sm font-semibold"> {item.title}</b>
                  <i className="text-opacity-0 text-[#c84e47] text-xs">
                    | The Asia Wander
                  </i>
                </span>

                <span className="w-full mt-0.5 font-medium text-[10px] text-[#363f4d] line-clamp-3">
                  {item.description}
                </span>
              </div>
            </div>
          </Link>
        );
      })}
    </>
  );
};

export default CardGrey;
